<template>
  <div style="text-align: right;position: relative;">
    <div v-show="isalerts" class="hint">*提示1：请在=>后面填写相关内容</div>
    <div v-show="isalerts" class="hint">*提示2：请不要在标题、原文件首页、原文件尾页处，添加文字样式和格式</div>
    <div v-show="isalerts" class="hint">*提示3：文章内容请填写在两个<=中间</div>
    <el-button  v-show="isalerts" style="position: absolute;top: 45px;right: 0;" type="primary" @click="btn()">识别</el-button>
    <ckeditor :editor="editor" v-model="editorData" @ready="onReady" :config="editorConfig" id="editor"></ckeditor> 
    <!-- <div class="tinymce-editor">
      <editor v-model="editorData"
        :init="init"
        :disabled="disabled"
        @onClick="onClick">
      </editor>
    </div> -->
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/zh-cn";
import axios from "axios";

// import tinymce from 'tinymce/tinymce'
// import 'tinymce/themes/modern/theme'
// import 'tinymce/themes/silver/theme'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/media'// 插入视频插件
// import 'tinymce/plugins/link'
// import 'tinymce/plugins/code'
// import 'tinymce/plugins/table'
// import 'tinymce/plugins/lists'
// import 'tinymce/plugins/contextmenu'
// import 'tinymce/plugins/wordcount'
// import 'tinymce/plugins/colorpicker'
// import 'tinymce/plugins/textcolor'
// import Editor from '@tinymce/tinymce-vue'

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }
  async upload() {
    let url = sessionStorage.getItem("$url");
    const data = new FormData();
    data.append("typeOption", "upload_image");
    data.append("file", await this.loader.file);
    return new Promise((resolve, reject) => {
      axios({
        url: `${url}/periodical/web/ckeditor/upload`,
        method: "post",
        data,
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token") // 此处为你定义的token 值(Bearer token 接口认证方式)
        },
        withCredentials: false // 此处可删掉，没发现有什么用
      })
        .then(res => {
          var resData = res.data.data;
          resData.default = `${url}` + resData.url;
          resolve(resData);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  
}


export default {
  // components: {
  //   Editor
  // },//tinymce插件需要改组件 如不需要则隐藏
  props: {
    isalerts:{
      type:Boolean
    },
    formats:{
      type:String,
      default: ''
    },
    //tinymce插件传入一个value，使组件支持v-model绑定
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'lists image media table paste textcolor wordcount contextmenu'
    },
   toolbar: {
      type: [String, Array],
      // default: 'undo redo |  formatselect | bold italic underline strikethrough| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
      default: 'bold italic  | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify  | link unlink image media code | removeformat'
    }
  },
  
  data() {
    
    return {
      editor: ClassicEditor,//ckeditor 插件如换插件则隐藏该属性
      editorData: this.formats,
      editorConfig: {
        pasteFromWordRemoveFontStyles : false,
        pasteFromWordRemoveStyles : false,  
        forcePasteAsPlainText:false,//不去除
        language: "zh-cn",
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            "default",
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            36,
            44,
            48,
            72
          ]
        },
        highlight: {
          /* options: [
            {
              model: "blackPen",
              class: "pen-black",
              title: "黑色",
              color: "var(--ck-highlight-pen-black)",
              type: "pen"
            },
            {
              model: "redPenPen",
              class: "pen-red",
              title: "红色",
              color: "var(--ck-highlight-pen-red)",
              type: "pen"
            }
          ] */
        }
      },
      ckfinder: {
        // 　　　　　　uploadUrl: `https://ryit.natapp4.cc/periodical/web/upload`,
        uploadUrl: `https://api.ccenews.com.cn/periodical/web/upload`,
        // 后端处理上传逻辑返回json数据,包括uploaded 上传的字节数 和url两个字段
        
      },
      Editortext:'', //新加的tinymce
      //初始化配置
       init: {
        language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide',
        height: 300,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        paste_data_images: true, //可以保留图片
        powerpaste_word_import: 'merge', // 是否保留word粘贴样式  clean | merge 
        //此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        //如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          success(img)
        }
      },
      myValue: this.value
    };
  },


  mounted() {
    // tinymce.init({});//tinymce插件 不需要则隐藏
    this.editorData =  this.formats;
    // console.log("this.editor",this.editor )
    console.log("this.editorData ",this.editorData)

    
  },
  methods: {
    onClick(e) {
      // console.log("tinymce",e)
      this.$emit('onClick', e, tinymce)
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear() {
      console.log("clear")
      this.myValue = ''
    },
    //初始化方法 暂不用
    tinymce() {
                let _this = this;


                //这一句代码是重点 不写会报错theme.js:1 Uncaught SyntaxError: Unexpected token <
                _this.$tinymce.baseURL = '/static/tinymce'


                _this.$tinymce.init({
                    selector: "#Editor",
                    language_url: '../../../../static/tinymce/zh_CN.js',//设置中文
                    language: 'zh_CN',
                    plugins: [ //配置插件：可自己随意选择，但如果是上传本地图片image和imagetools是必要的
                        'advlist autolink link image lists charmap  preview hr anchor pagebreak ',
                    ],
                    //工具框，也可自己随意配置
                    toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image ',
                    image_advtab: true,
                    table_default_styles: {
                        width: '100%',
                        borderCollapse: 'collapse'
                    },
                    image_title: false, // 是否开启图片标题设置的选择，这里设置否
                    automatic_uploads: true,
                    // 图片异步上传处理函数
                    images_upload_handler: (blobInfo, success, failure) => {
                        var formData;
                        formData = new FormData();
                        formData.append('images',blobInfo.blob(), blobInfo.filename());
                            // _this.$api.uploadScenicFace这个是我调用后台图片上传接口的函数
                            _this.$api.uploadScenicFace(formData, _this.token, function(data) {
                                // 图片上传成功以后调用success,图片就可以在富文本编辑器中显示了
                                success(data.url);
                            });
                    },
                    init_instance_callback: function(editor) {
                        editor.on('keyup', () => {
                            // 获取富文本编辑器里面的内容
                            _this.Editortext = editor.getContent();
                        });
                    }
                }).then(resolve => {
                    // 初始化富文本编辑器里面的内容
                    resolve[0].setContent(_this.Editortext)
                });
            },

    updateData(e = "") {
            let c1 = e.replace(/<img width="100%"/g, "<img");
            let c2 = c1.replace(/<img/g, '<img width="100%"');
            this.content = c2;
            console.log(this.content);
        },

    btn() {
    /*   var test = `<p>标题</p>
                <p>=>1</p>
                <p>副标题</p>
                <p>=>2</p>
                <p>作者</p>
                <p>=>3</p>
                <p>作者单位</p>
                <p>=>4</p>
                <p>原文页面首页</p>
                <p>=>5</p>
                <p>原文页面尾页</p>
                <p>=>6</p>
                <p>内容</p>
                <p>=>7</p>
                `; */
      var reg = /<p>=&gt;+(([\s\S])*?)<\/p>/gi;
      // var reg1 = /[^><]+(?=<\/p>)/gi;

      // var reg = /<p>=&gt;+(([\s\S])*?)<\/p>/gi;
//       var reg = /=&gt;+(([\s\S])*?)=&gt;/gi;
      var reg1 = /&lt;=+(([\s\S])*?)&lt;=/gi;
      // var reg = />+(([\s\S])*?)<\//gi;
      // var reg = /(?:<(\w+?)>)([^<]+)(?=<\/\1>)/gi

      var me = this.editorData.match(reg)
      var me1 = this.editorData.match(reg1)
      console.log(me)
      if(me!=null && me.length==3){ //不要副标题subheading 作者 作者地址 由6改为3
        var arr = []
        var arr1 = []
        for(let i =0;i<me.length;i++){
          if(me[i] == '<p>=&gt;</p>'){
            this.$toast("error", '请在所有=>后面填写相关内容');
            return false
          }else{
            arr.push(me[i].substring(0,me[i].length-4))
          }
        }
        for(let i=0;i<arr.length;i++){
          arr1.push(arr[i].substring(8))
        }
        var data =  {}
        data.headline = arr1[0]
        // data.subheading = arr1[1]
        // data.author = arr1[1]
        // data.unit = arr1[2]
        data.homepage = arr1[1]
        data.trailerpage = arr1[2]
        var str = ''
        var str1 = ''
        str = me1[0].substring(0,me1[0].length-8)
        str1 = str.substring(9)
        if(str1==''){
          this.$toast("error", '请在两个<=中间填写相关内容');
        }else{
          data.msg = str1
        this.$emit('istruedata',data)
        }
      }else{
        this.$toast("error", '请在所有=>后面填写相关内容');
      }
    },
    onReady(editor) {
      // 自定义上传图片插件
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new MyUploadAdapter(loader);
      };

    },
    initCKEditor() {
        console.log("触发initCKEditor")
        var a = document.getElementById("editor"); //取得纯文本
        console.log("a",a)
        // ClassicEditor.on("instanceReady", function () {
 
        //       //监听粘贴事件
        //       this.document.on("paste", function(e) {
            
        //         setTimeout(function(){
                  
                  var p =document.getElementById("editor").getElementsByTagName("p") ; //找到p标签
                  console.log("p",p)
                  let count = p.length;
                  console.log("count",count)

                  let arr = [];
                  for(var i = 0; i < count; i++) {
                    // var item = p.getItem(i).html;
                    //找到每一个p元素
                    var item = p[i]; 
                    //判断是否有子元素，用于判断是否p标签里面有图片的情况，具体要根据实际情况进行判断
                    if(item.children.length<1){
                      console.log("item",item)
                      // var html = item.innerHTML;
                      var html = item;
                      if(html){
                        console.log("html",html)
                        //因为text-indent会被编辑器默认过滤掉，所以需要使用全角字符“　”代替缩进，这个空白字符代表一个中文字符长度，非空白键。
                        // html = html.replace(/　/g,''); //过滤部分网站已经存在的缩进符号，如新浪新闻就是使用全角空白符代替缩进的。
                        // item.html = '&nbsp;&nbsp;'+html; //从新设置内容
                        // item.innerHTML= '&nbsp;&nbsp;'+html; //从新设置内容
                        item =html; //从新设置内容
                        console.log("新的item",item);
                        p[i].html = item.innerHTML;
                        console.log("p",p[i].html)
                        
                        this.contenthHTML = this.contenthHTML.concat(item.innerHTML);
                        console.log("this.contenthHTML",this.contenthHTML)
                        
                        
                        
                        // this.editorData = this.contenthHTML.join("");
                        
                        //视图没有更新 
                        
                      }
                      
                    }

                  }

                  var a = [];
                  let list = this.contenthHTML;
                    for (var i = 0; i < list.length; i ++) {
                        a.push(list);
                    }
                    var str = a.join('');
                    console.log("str",str)
                  // let arr = [];
                  // this.contenthHTML = p;
                  // console.log("this.contenthHTML",this.contenthHTML)








                  
                // },500);
            
              // });
            },
    
     
    
  },
  watch: {
    
    editorData(val){
      
      if(!this.isalerts){
        // console.log("this.editorData",val)
        this.$emit('isfalsedata',val)
      }
    },
    formats(val){
      // console.log("this.formats",val) //富文本内容
      this.editorData = val;
      // this.initCKEditor(); //新增方法
    },
    isalerts(val){
      this.editorData =  this.formats;
      console.log(val,'哈哈哈哈哈哈')
    },
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>



<style lang="scss" scoped>
/deep/.ck-editor__editable {
  min-height: 350px;
}
.hint{
  text-align: left;
  color: #F56C6C;
  font-size: 16px;
  margin:0.2rem 0;
}


</style>
